import StaticHero from './StaticHero';

export default StaticHero;



// WEBPACK FOOTER //
// ./src/components/shared/StaticHero/index.js